export default __webpack_public_path__ + "images/I8.673f79e.png";